import { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import isEqual from "lodash/isEqual";
var filtersFromSearch = function (search) {
    var sp = new URLSearchParams(search);
    return { number: sp.get("number") || "", name: sp.get("name") || "" };
};
export var useOnixCodetablesFilters = function () {
    var history = useHistory();
    var location = useLocation();
    var initial = { number: "", name: "" };
    // Initialised from the URL in the first render: filters patched in by an
    // effect afterwards would change the search and send it twice.
    var _a = useState(function () {
        return filtersFromSearch(location.search);
    }), filters = _a[0], setFilters = _a[1];
    var _b = useState(filters.number), temporaryNumberFilter = _b[0], setTemporaryNumberFilter = _b[1];
    var _c = useState(filters.name), temporaryNameFilter = _c[0], setTemporaryNameFilter = _c[1];
    var updateUrlWithFilters = useCallback(function (f) {
        var params = new URLSearchParams();
        if (f.number)
            params.set("number", f.number);
        if (f.name)
            params.set("name", f.name);
        history.push({ search: params.toString() });
    }, [history]);
    var handleApplyFilters = function () {
        var newFilters = {
            number: temporaryNumberFilter,
            name: temporaryNameFilter,
        };
        setFilters(newFilters);
        updateUrlWithFilters(newFilters);
    };
    var handleClearFilters = function () {
        setTemporaryNumberFilter("");
        setTemporaryNameFilter("");
        setFilters(initial);
        history.push({ search: "" });
    };
    var isAnyFilterActive = function () { return !!(filters.number || filters.name); };
    useEffect(function () {
        var fromUrl = filtersFromSearch(location.search);
        setFilters(function (prev) { return (isEqual(prev, fromUrl) ? prev : fromUrl); });
        setTemporaryNumberFilter(fromUrl.number);
        setTemporaryNameFilter(fromUrl.name);
    }, [location.search]);
    return {
        filters: filters,
        temporaryNumberFilter: temporaryNumberFilter,
        temporaryNameFilter: temporaryNameFilter,
        setTemporaryNumberFilter: setTemporaryNumberFilter,
        setTemporaryNameFilter: setTemporaryNameFilter,
        handleApplyFilters: handleApplyFilters,
        handleClearFilters: handleClearFilters,
        isAnyFilterActive: isAnyFilterActive,
    };
};
